@if (!value) {
  <div>
    <h3 style="color: darkred">Contact value not set</h3>
  </div>
}
@if (value) {
  <div>
    @if (value.roleName) {
      <div class="role-title">
        {{ value.roleName }}
      </div>
    }
    <div class="contact-data-container text-left">
      @if (value && fullName) {
        <div>
          <b>Contact: </b>{{ fullName }}
          <link-to-stripe [emailAddress]="value.emailAddress"></link-to-stripe>
          @if (value.userAccountId) {
            <link-to-user-account-detail
              [openInNewTab]="true"
              [userAccountId]="value.userAccountId"
            ></link-to-user-account-detail>
          }
        </div>
      }
      @if (value && value.emailAddress) {
        <div><b>Email: </b>{{ value.emailAddress }}</div>
      }
      @if (value && (value.phone | phoneNumber)) {
        <div><b>Phone: </b>{{ value.phone | phoneNumber }}</div>
      }
      @if (hasAddress && showAddress) {
        @if (value.address.street) {
          <div class="col-sm-12">
            <span><b>Street: </b>{{ value.address.street }}</span>
          </div>
        }
        @if (value.address.street2) {
          <div class="col-sm-12">
            <span><b>Street2: </b>{{ value.address?.street2 }}</span>
          </div>
        }
        @if (value.address.city) {
          <div class="col-sm-12">
            <span><b>City: </b>{{ value.address.city }}</span>
          </div>
        }
        @if (value.address.state) {
          <div class="col-sm-12">
            <span><b>State: </b>{{ value.address.state }}</span>
          </div>
        }
        @if (value.address.zip) {
          <div class="col-sm-12">
            <span><b>Zip Code: </b>{{ value.address.zip }}</span>
          </div>
        }
      }
    </div>
    <!-- <button (click)="showData()"> show data</button> -->
  </div>
}
